// extracted by mini-css-extract-plugin
export default {"root":"NotFound404_root__-aMno","img":"NotFound404_img__cAg-P","title":"NotFound404_title__jzWfp","text":"NotFound404_text__uq07K"};